import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import { formatRegistrationDate } from '../../../../../components/common/time/timeHelper'
import './checks.scss'

const CheckJapJus = ({ jap_jus, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])

  const hasChecks = jap_jus?.checkDetails && jap_jus.checkDetails.TotalLawsuits
  const checkLength = jap_jus.checkDetails.TotalLawsuits || 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:lawsuits')} {t('common:company')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} label="Processo" />
      </Paper>

      <CheckDetailTitle email={jap_jus?.email} status={jap_jus?.status} createdAt={jap_jus?.createdAt} updatedAt={jap_jus?.updatedAt} />

      {hasChecks ? (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalLawsuits')}</Typography>
                <Typography variant="subtitle3">{jap_jus.checkDetails.TotalLawsuits ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:totalLawsuits')} {t('common:asAuthor')}
                </Typography>
                <Typography variant="subtitle3">{jap_jus.checkDetails.TotalLawsuitsAsAuthor ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:totalLawsuits')} {t('common:asDefendant')}
                </Typography>
                <Typography variant="subtitle3">{jap_jus.checkDetails.TotalLawsuitsAsDefendant ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:totalLawsuits')} {t('common:asOther')}
                </Typography>
                <Typography variant="subtitle3">{jap_jus.checkDetails.TotalLawsuitsAsOther ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
               <Typography variant="subtitle1">{t('common:firstLawsuitDate')}</Typography>
                  <Typography variant="subtitle3">{formatRegistrationDate(jap_jus.checkDetails.FirstLawsuitDate).endsWith('1901')
                      ? '---'
                      : formatRegistrationDate(jap_jus.checkDetails.FirstLawsuitDate)}
                  </Typography>
              </div>
               <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:lastLawsuitDate')}</Typography>
                  <Typography variant="subtitle3">{formatRegistrationDate(jap_jus.checkDetails.LastLawsuitDate).endsWith('9999')
                      ? '---'
                      : formatRegistrationDate(jap_jus.checkDetails.LastLawsuitDate)}
                  </Typography>
                </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:last30')} {t('common:lawsuits')}
                </Typography>
                <Typography variant="subtitle3">{jap_jus.checkDetails.Last30DaysLawsuits ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:last90')} {t('common:lawsuits')}
                </Typography>
                <Typography variant="subtitle3">{jap_jus.checkDetails.Last90DaysLawsuits ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:last180')} {t('common:lawsuits')}
                </Typography>
                <Typography variant="subtitle3">{jap_jus.checkDetails.Last180DaysLawsuits ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:last365')} {t('common:lawsuits')}
                </Typography>
                <Typography variant="subtitle3">{jap_jus.checkDetails.Last365DaysLawsuits ?? '---'}</Typography>
              </div>
              {jap_jus.checkDetails.informação && (
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:information')}</Typography>
                  <Typography variant="subtitle3">{jap_jus.checkDetails.informação}</Typography>
                </div>
              )}
            </div>
          </Paper>
        </TimelineDotLine>
      ) : (
        <Paper elevation={0} sx={{ flex: 1 }}>
          <Typography variant="body1" sx={{ marginTop: 2 }}>
            {t('messages:noDataCheckAvailable')}
          </Typography>
        </Paper>
      )}
    </>
  )
}

export default CheckJapJus
